import { CheckIcon, XIcon } from "@heroicons/react/outline";

import { Button } from "@/components/ui/button";

interface EditPanelActionsProps {
  onSave: () => void;
  onCancel: () => void;
}

const EditPanelActions = ({ onSave, onCancel }: EditPanelActionsProps) => (
  <div className="ml-auto flex shrink-0 items-center gap-1.5 pt-0.5">
    <Button
      variant="outline"
      size="sm"
      onClick={onSave}
      className="h-8 w-8 border-green-200 bg-green-50 p-0 text-green-600 hover:bg-green-100 hover:text-green-700"
    >
      <CheckIcon className="h-4 w-4" />
    </Button>
    <Button
      variant="outline"
      size="sm"
      onClick={onCancel}
      className="h-8 w-8 border-slate-200 bg-white p-0 text-slate-400 hover:bg-slate-100 hover:text-slate-600"
    >
      <XIcon className="h-4 w-4" />
    </Button>
  </div>
);

export default EditPanelActions;
